(function ($) {
  $(document).ready(() => {
    const $icon = $('.search-icon');

    $icon.on('click', () => {
      location.href = '/zoeken';
    });

    const focusablePaths = ['/zoeken', '/webwinkel'];
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    if (focusablePaths.includes(currentPath)) {
      const focusSearchInput = () => {
        const $searchInput = $('.ais-SearchBox-input:visible').first();
        const hasSearchInput = Boolean($searchInput.length);

        if (!hasSearchInput) {
          return hasSearchInput;
        }

        $searchInput.trigger('focus');

        const input = $searchInput.get(0);

        if (input && input.setSelectionRange) {
          const textLength = input.value.length;
          input.setSelectionRange(textLength, textLength);
        }

        return hasSearchInput;
      };

      if (!focusSearchInput()) {
        setTimeout(focusSearchInput, 100);
      }
    }
  });
})(jQuery);
